import script from "./VetRecordTableRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./VetRecordTableRow.vue?vue&type=script&lang=ts&setup=true"

import "./VetRecordTableRow.vue?vue&type=style&index=0&id=32787c19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32787c19"]])

export default __exports__